import * as React from "react";
import type { SVGProps } from "react";
const Main = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={33} cy={33.5} r={25} fill="#FDFDFD" />
      <g strokeLinejoin="round">
        <circle cx={33} cy={33.5} r={26.5} stroke="#FFF" strokeWidth={3} />
        <circle cx={33} cy={33.5} r={26} stroke="#000" strokeWidth={2} />
      </g>
      <path
        fill="#000"
        d="m26.168 27.147 11.292-1.552 5.357 10.066-8.24 7.875-10.465-5.201 2.056-11.188Zm-15.919-6.699c1.355-2.615 2.546-4.42 3.575-5.414 1.03-.994 2.889-2.138 5.579-3.431l5.11 2.292-3.31 8.688-8.914 3.012-2.04-5.147ZM59.3 32.485c-.168 2.627-.358 4.642-.57 6.045-.214 1.403-.997 3.378-2.35 5.927l-6.367.506-1.453-8.146 4.54-9.389 6.2 5.057Zm-15.643 24.39c-2.816 1.249-4.944 1.93-6.383 2.041-1.438.112-3.724.112-6.858 0l-3.973-5.293 9.772-4.314 8.028 1.399-.586 6.166ZM11.635 49.66c-1.639-2.212-2.639-4.004-3-5.377A59.609 59.609 0 0 0 7.3 39.94l3.595-7.255 6.42 7.53.81 10-6.49-.556ZM38.373 9c2.286.255 4.09.666 5.414 1.23 1.324.566 3.063 1.82 5.217 3.764l.477 5.035-10.032-.43-7.603-6.414L38.373 9Z"
      />
    </g>
  </svg>
);
export default Main;
